export enum PayeeValidationType {
  IDFC = 'IDFC_VALIDATION',
  HDFC = 'HDFC_VALIDATION',
  DIGIO = 'DIGIO_VALIDATION'
}
